import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { formatDate, dateTimeSaparator } from '../../../../helper/formatDate';
import {
    getWhatsAppAppUrl,
    getWhatsAppWebUrl,
    getServiceBadgeClass,
    getTrialStatus
} from '../EnquiryList/enquiryUtils';
import { FollowUpHistoryModal } from '../FollowUpHistoryModal';
import { FollowUpBtn } from '../FollowUpBtn';
import { MeetingWhatsAppModal } from './MeetingWhatsAppModal';

export const MeetingMobileCard = ({ row, handleReport, handleFollowSuccess }) => {
    const enq = row.enquiry || {};
    const serviceName = enq.course?.name || '';
    const serviceBadge = getServiceBadgeClass(serviceName);
    const trialStatus = getTrialStatus(enq.tryal_date, enq.tryal_period);

    const callDT = dateTimeSaparator(row.created_at);
    const user = row.callerUser;
    const userName = user
        ? `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username || `Staff #${user.id}`
        : 'System / Staff';

    const appUrl = getWhatsAppAppUrl(enq.whatsapp, enq.phone, enq.name);
    const webUrl = getWhatsAppWebUrl(enq.whatsapp, enq.phone, enq.name);

    return (
        <div className="card border shadow-none mb-2 rounded-3 w-100 overflow-hidden">
            {/* Header: School Name, Badges & Meeting Status */}
            <div className="card-header bg-light-subtle py-2 px-3 border-bottom d-flex align-items-center justify-content-between flex-wrap gap-2">
                <div style={{ minWidth: 0, maxWidth: '70%' }}>
                    <span
                        role="button"
                        onClick={() => handleReport && handleReport(row)}
                        className="fw-bold text-dark fs-14 text-truncate d-block school-name-link cursor-pointer"
                    >
                        {enq.name || 'Candidate / School'}
                    </span>
                    <div className="d-flex align-items-center gap-1.5 mt-0.5 flex-wrap">
                        {trialStatus && (
                            <span className={`badge ${trialStatus.badgeClass} fs-10 px-1.5 py-0.5`}>
                                {trialStatus.label}
                            </span>
                        )}
                        {serviceName && (
                            <span className={`service-pill-badge ${serviceBadge} fs-10`}>
                                {serviceName}
                            </span>
                        )}
                    </div>
                </div>
                <span className="badge bg-soft-info text-info fs-11 px-2 py-0.5 fw-semibold">
                    Meeting Arrange
                </span>
            </div>

            {/* Body: Meeting Date, Followed By User, Contact, Remark */}
            <div className="card-body p-3">
                {/* Scheduled Meeting Date & Followed By User */}
                <div className="d-flex align-items-center justify-content-between mb-2 fs-12 flex-wrap gap-1">
                    {row.meetingDate ? (
                        <span className="badge bg-soft-info text-info border border-info-subtle px-2 py-1 fs-11 fw-semibold d-inline-flex align-items-center gap-1">
                            <i className="ri-calendar-check-fill" />
                            <span>Meeting: {formatDate(row.meetingDate)}</span>
                        </span>
                    ) : (
                        <span className="text-muted fst-italic fs-11">No date set</span>
                    )}

                    <span className="text-muted d-inline-flex align-items-center gap-1 fs-11">
                        <i className="ri-user-line text-primary" />
                        <span className="fw-medium text-dark">{userName}</span>
                        {callDT.date && <span>({callDT.date})</span>}
                    </span>
                </div>

                {/* Principal & Phone */}
                <div className="d-flex align-items-center justify-content-between mb-2 fs-12">
                    {enq.father_name && (
                        <span className="text-muted text-truncate" style={{ maxWidth: '160px' }}>
                            <i className="ri-user-star-line me-1" />
                            {enq.father_name}
                        </span>
                    )}
                    <a
                        href={`tel:${enq.phone}`}
                        className="text-success fw-semibold text-decoration-none d-inline-flex align-items-center ms-auto"
                    >
                        <i className="bx bx-phone me-1 fs-14" />
                        {enq.phone || 'N/A'}
                    </a>
                </div>

                {/* Remark Box */}
                <div
                    className="p-2 bg-light-subtle rounded border border-light-subtle fs-12 text-body lh-sm mb-2"
                    style={{ whiteSpace: 'pre-wrap' }}
                >
                    {row.remark || <span className="text-muted fst-italic">No conversation notes recorded.</span>}
                </div>

                {/* Actions Row */}
                <div className="d-flex align-items-center justify-content-between pt-2 border-top border-light-subtle flex-wrap gap-2 fs-12">
                    <button
                        type="button"
                        className="btn btn-sm btn-link text-primary p-0 d-inline-flex align-items-center text-decoration-none"
                        onClick={() => handleReport && handleReport(row)}
                    >
                        <i className="ri-file-list-3-line me-1" />
                        Report
                    </button>

                    <div className="d-flex align-items-center gap-1 ms-auto">
                        {/* WhatsApp Meeting Invitation Modal */}
                        <MeetingWhatsAppModal row={row}>
                            <button
                                type="button"
                                className="btn btn-sm btn-soft-success py-1 px-2 border-0 d-inline-flex align-items-center"
                                title="Send Meeting Link on WhatsApp"
                            >
                                <i className="ri-whatsapp-line fs-14 text-success" />
                            </button>
                        </MeetingWhatsAppModal>

                        {/* History */}
                        <FollowUpHistoryModal enquiryId={enq.id} schoolName={enq.name}>
                            <button className="btn btn-sm btn-soft-primary py-1 px-2" title="View Call History">
                                <i className="ri-chat-3-line fs-13" />
                            </button>
                        </FollowUpHistoryModal>

                        {/* FollowUp Action Button */}
                        <FollowUpBtn follow={row} onSuccess={handleFollowSuccess} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeetingMobileCard;
